import { InjectionToken } from '@angular/core';
import { MatSnackBarConfig } from '@angular/material/snack-bar';

export interface SnackbarFacadeContract {
  queueSnackBar(message: string, configParams?: MatSnackBarConfig): void;
}

export const SNACKBAR_FACADE = new InjectionToken<SnackbarFacadeContract>(
  'SNACKBAR_FACADE',
);
